export default {
  LOAD_DATA: "LOAD_DATA",
  OPEN_CREATE_FORM: "OPEN_CREATE_FORM",
  OPEN_EDIT_FORM: "OPEN_EDIT_FORM",
};
